import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { lazyRetry } from '@utils/lazyRetry';
import { layoutConfigOnlyMain } from '@/configs/layoutConfigTemplates';

const IntakeStationApp = lazyRetry(() => import('./IntakeStationApp'));

// Desktop Intake Station — Tauri concept page (design-only, dummy data).
// Full-viewport with no Fuse chrome to mirror the standalone desktop app feel.
// Auto-registered by routesConfig.tsx via the `/src/app/**Route.tsx` Vite glob.
const IntakeStationRoute: FuseRouteItemType = {
  path: 'intake-station',
  element: <IntakeStationApp />,
  settings: { layout: layoutConfigOnlyMain }
};

export default IntakeStationRoute;
